import { render, staticRenderFns } from "./funds.vue?vue&type=template&id=1073cde0&scoped=true"
import script from "./funds.vue?vue&type=script&lang=js"
export * from "./funds.vue?vue&type=script&lang=js"
import style0 from "./funds.vue?vue&type=style&index=0&id=1073cde0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1073cde0",
  null
  
)

export default component.exports